import { NgModule } from '@angular/core';

@NgModule({})

    //uibModal
export abstract class $uibModal {
    [key: string]: any;
}

export function $uibModalFactory(i: any) {
    return i.get('$uibModal');
}

export const $uibModalProvider = {
    provide: $uibModal,
    useFactory: $uibModalFactory,
    deps: ['$injector']
};


//http
export abstract class $http {
    [key: string]: any;
}

export function $httpFactory(i: any) {
    return i.get('$http');
}

export const $httpProvider = {
    provide: $http,
    useFactory: $httpFactory,
    deps: ['$injector']
};


//routeParams
export abstract class $routeParams {
    [key: string]: any;
}

export function $routeParamsFactory(i: any) {
    return i.get('$routeParams');
}

export const $routeParamsProvider = {
    provide: $routeParams,
    useFactory: $routeParamsFactory,
    deps: ['$injector']
};



//setup service

export abstract class SetupService {
    [key: string]: any;
}

export function SetupServiceFactory(i: any) {
    return i.get('SetupService');
}

export const SetupServiceProvider = {
    provide: SetupService,
    useFactory: SetupServiceFactory,
    deps: ['$injector']
};


//main/objects/MainMenu service

export abstract class MainMenuService {
    [key: string]: any;
}

export function MainMenuFactory(i: any) {
    return i.get('MainMenu');
}

export const MainMenuProvider = {
    provide: MainMenuService,
    useFactory: MainMenuFactory,
    deps: ['$injector']
};



